
import {firstValueFrom, Observable, of} from 'rxjs';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {PendingChangesDialogComponent} from './pending-changes-dialog/pending-changes-dialog.component';
import {map} from 'rxjs/operators';
import { Injectable } from "@angular/core";
import {BreakpointObserver} from "@angular/cdk/layout";
import {BREAKPOINTS} from "../shared/constants/breakpoints";

export interface ComponentCanDeactivate {
  canDeactivate: () => Promise<boolean>;
}

@Injectable()
export class PendingChangesGuard  {
  constructor(private dialog: MatDialog, private media: BreakpointObserver) {

  }

  canDeactivate(component: ComponentCanDeactivate): Promise<boolean> {
    // if there are no pending changes, just allow deactivation; else confirm first
    if (component.canDeactivate()) {
      return firstValueFrom(of(true));
    }

    const config = new MatDialogConfig();
    if (this.media.isMatched(BREAKPOINTS.Standard.XSmall)) {
      config.width = '90vw';
    } else {
      config.width = '320px';
    }

    const dialogRef = this.dialog.open(PendingChangesDialogComponent, config);

    return firstValueFrom(
        dialogRef
        .afterClosed()
        .pipe(
          map( (result) => {
            return result === 'leave';
          })
        )
    );
  }
}
